import { Joi, objectSchemaOf } from '../helpers';

export interface ILoadPhrasesParams {
  consoleId?: string;
}

export const loadPhrasesParamsSchema = objectSchemaOf<ILoadPhrasesParams>({
  consoleId: Joi.string(),
});

export interface IVoiceToTextPhrase {
  organisationId: string;
  consoleIds: string[];
  phrases: string[];
}

export const voiceToTextPhraseSchema = objectSchemaOf({
  organisationId: Joi.string().required(),
  consoleIds: Joi.array().items(Joi.string()),
  phrases: Joi.array().items(Joi.string()),
});

export type LoadPhrasesResult = IVoiceToTextPhrase[];

export const loadPhrasesResultSchema = Joi.array().items(
  voiceToTextPhraseSchema
);
